module.exports = __webpack_public_path__ + "img/image-20220714-173049.d33fd568.png";